// Destino por defecto del login (sin `?returnTo=`). Va a Productos, la
// pantalla de trabajo de casi todos los roles. La entrada con Effetá Apps sin
// destino vuelve a `/login`, que con la sesión abierta navega acá.
//
// La navegación lleva una marca en `location.state`: si el rol no abre ese
// módulo, el guard no lo trata como un acceso prohibido que el user pidió y lo
// manda a `/`, donde la regla de Inicio elige su sección (ver
// `useHomeTarget`). Se decide en el guard, que se evalúa en cada render: así
// también aplica si los permisos llegan después de navegar.
export const DEFAULT_LANDING_PATH = '/products';

export const DEFAULT_LANDING_STATE = { isDefaultLanding: true } as const;

export function isDefaultLanding(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as { isDefaultLanding?: unknown }).isDefaultLanding === true
  );
}
